import { render, staticRenderFns } from "./AdminHome.vue?vue&type=template&id=01360f0c&scoped=true"
import script from "./AdminHome.vue?vue&type=script&lang=js"
export * from "./AdminHome.vue?vue&type=script&lang=js"
import style0 from "./AdminHome.vue?vue&type=style&index=0&id=01360f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01360f0c",
  null
  
)

export default component.exports